interface OverrideOlderVersionModalProps {
  viewingVersion: number
  latestVersion: number
  onConfirm: () => void
  onCancel: () => void
}

export function OverrideOlderVersionModal({
  viewingVersion,
  latestVersion,
  onConfirm,
  onCancel,
}: OverrideOlderVersionModalProps) {
  const nextVersion = latestVersion + 1
  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4"
      onClick={onCancel}
      role="presentation"
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full p-6"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="override-modal-title"
      >
        <h2
          id="override-modal-title"
          className="text-lg font-semibold mb-3 text-gray-900"
        >
          Save on top of the latest version?
        </h2>
        <p className="text-sm text-gray-700 mb-4 leading-relaxed">
          You're editing <b>v{viewingVersion}</b>, but <b>v{latestVersion}</b>
          {' '}is the current latest. Saving will append{' '}
          <b>v{nextVersion}</b> on top of v{latestVersion}. Your edits become
          the new latest; v{latestVersion} stays in history.
        </p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-100 rounded transition-colors"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-3 py-1.5 text-sm bg-slate-800 text-white hover:bg-slate-900 rounded transition-colors"
            onClick={onConfirm}
          >
            Save as v{nextVersion}
          </button>
        </div>
      </div>
    </div>
  )
}
